module.exports = __webpack_public_path__ + "static/icon-fe91f1403856ae86862745aa0147eade.png";